import type { ProductDetailRaw, ProductDetailUI, ProductListRaw, ProductRow } from "~/features/admin/products/types";

function toProductRow(raw: ProductListRaw): ProductRow {
  return {
    id: raw.id,
    name: raw.name,
    originHosts: raw.originHosts,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toProductRowList(raws: readonly ProductListRaw[]): ProductRow[] {
  return raws.map(toProductRow);
}

export function toProductDetailUI(raw: ProductDetailRaw): ProductDetailUI {
  return {
    id: raw.id,
    name: raw.name,
    originHosts: raw.originHosts,
    importDirectWebhookUrl: raw.importDirectWebhookUrl ?? null,
    availableRoles: raw.productRoles.map((pr) => pr.role.name),
    availableRoleIds: raw.productRoles.map((pr) => pr.role.id),
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
    deactivatedAt: raw.deactivatedAt ?? null,
  };
}
